"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useFormGroup_1 = require("../../hooks/useFormGroup");
const Box_1 = require("../Box");
exports.Label = react_1.forwardRef(function Label(props, ref) {
    const { id } = useFormGroup_1.useFormGroup();
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "label", textAlign: "left", mb: 1, fontWeight: "bold", fontSize: "sm", opacity: 0.8, style: { userSelect: 'none' }, ref: ref }, { htmlFor: id }, props), void 0));
});
//# sourceMappingURL=index.js.map